import React from 'react';
import { EMP_DETAILS_TYPE } from '../../../utils/Constant';
import EmployeeDetails from './EmployeeDetails';
import { ROLE_MANAGEMENT_HEADER } from '../AdminSettingsHelper';

const RoleManagementPage: React.FunctionComponent = () => {
  return (
    <EmployeeDetails
      detailType={EMP_DETAILS_TYPE.ROLE}
      columnsHeder={ROLE_MANAGEMENT_HEADER}
      title="Role Management"
    />
  );
};
export default RoleManagementPage;
